"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = oneFlight;

var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/weak-map"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _apply = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/apply"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _wrap2 = _interopRequireDefault(require("lodash/wrap"));

var _templateContainer = _interopRequireDefault(require("./template-container"));

// Alias Map and WeakMap to get around a babel compiler bug
var W = _weakMap.default;
var M = _map.default;
var WeakMappedMappedMap = (0, _templateContainer.default)(W, M, M);
var flights = new WeakMappedMappedMap();
/**
 * @memberof Util
 * @param {Object} options
 * @param {Function} options.keyFactory
 * @param {boolean} options.cacheFailures
 * @param {boolean} options.cacheSuccesses
 * @returns {Function}
 */

function oneFlight() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (params.length === 3) {
    return (0, _apply.default)(oneFlightDecorator, null, params);
  }

  var options = params[0] || {};
  var cacheFailures = options.cacheFailures,
      cacheSuccesses = options.cacheSuccesses,
      keyFactory = options.keyFactory;
  return oneFlightDecorator;
  /**
   * @param {Object} target
   * @param {string} prop
   * @param {Object} descriptor
   * @private
   * @returns {Object}
   */

  function oneFlightDecorator(target, prop, descriptor) {
    var key = prop;
    descriptor.value = (0, _wrap2.default)(descriptor.value, function oneFlightExecutor(fn) {
      var _this = this;

      var innerKey = key;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (keyFactory) {
        innerKey = "".concat(innerKey, "_").concat(keyFactory.apply(void 0, args));
      }
      /* eslint no-invalid-this: [0] */


      var flight = flights.get(this, target, innerKey);

      if (flight) {
        return flight;
      }

      flight = (0, _apply.default)(fn, this, args);

      if (!cacheFailures && flight && flight.catch) {
        flight = flight.catch(function (reason) {
          flights.delete(_this, target, innerKey);
          return _promise.default.reject(reason);
        });
      }

      if (!cacheSuccesses && flight && flight.then) {
        flight = flight.then(function (result) {
          flights.delete(_this, target, innerKey);
          return result;
        });
      }

      flights.set(this, target, innerKey, flight);
      return flight;
    }); // This *should* make decorators compatible with AmpersandState class
    // definitions

    if ((0, _typeof2.default)(target) === 'object' && !target.prototype) {
      target[prop] = descriptor.value;
    }

    return descriptor;
  }
}
//# sourceMappingURL=one-flight.js.map
